import {type ReactNode} from 'react'
import {ScrollView, StyleSheet, View} from 'react-native'

import {useTheme} from '#/alf'
import {Text} from '#/components/Typography'

/**
 * A titled horizontal rail of capsule cards. Cards are laid out in a
 * single row that can be swiped / scrolled, matching the vertical-card
 * carousel style used for suggested videos elsewhere in the product.
 */
export function CapsuleRail({
  title,
  subtitle,
  emptyText,
  children,
}: {
  title: string
  subtitle?: string
  emptyText?: string
  children: ReactNode
}) {
  const t = useTheme()
  const cards = Array.isArray(children) ? children : [children]

  return (
    <View style={styles.section}>
      <View style={styles.heading}>
        <Text style={styles.title}>{title}</Text>
        {subtitle ? (
          <Text style={[styles.subtitle, t.atoms.text_contrast_medium]}>
            {subtitle}
          </Text>
        ) : null}
      </View>
      {cards.filter(Boolean).length === 0 && emptyText ? (
        <Text style={[styles.empty, t.atoms.text_contrast_medium]}>
          {emptyText}
        </Text>
      ) : (
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.row}
          decelerationRate="fast"
          snapToInterval={158}>
          {cards}
        </ScrollView>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  section: {
    marginBottom: 24,
  },
  heading: {
    paddingHorizontal: 4,
    marginBottom: 10,
    gap: 2,
  },
  title: {
    fontSize: 17,
    fontWeight: '800',
  },
  subtitle: {
    fontSize: 13,
  },
  row: {
    paddingHorizontal: 4,
    gap: 8,
  },
  empty: {
    paddingHorizontal: 4,
    fontSize: 13,
  },
})
